import { ThemeSliceState } from '../store/themeSlice';

export const isUsingDarkTheme = (state: ThemeSliceState) => state.theme.useDarkTheme;
